export const QTYPES = ["long_text", "short_text", "scale_1_10", "single_choice", "multi_choice", "checklist"];

export function templateAccess(user) {
  const isPrincipal = user?.role === "entrepreneur" && !user?.team_owner_id;
  const canAdvisory =
    ["advisor", "admin", "accelerator", "investor", "provider"].includes(user?.role) || isPrincipal;
  const canTeam = isPrincipal;
  return { canAdvisory, canTeam, canList: canAdvisory || canTeam || user?.role === "entrepreneur" };
}

export function emptyQuestion(i) {
  return {
    key: `q${i + 1}`,
    label: { en: "", fr: "" },
    type: "long_text",
    required: false,
    options: [],
  };
}

export function emptyPrompt(i) {
  return { key: `prompt_${i + 1}`, label: { en: "", fr: "" } };
}

export function emptyForm(sessionType = "internal_1_1", audience = "") {
  return {
    name: "",
    description: "",
    session_type: sessionType,
    audience: audience || (sessionType === "advisory" ? "advisor" : "teammate"),
    is_default: false,
    questions: [emptyQuestion(0)],
    after_questions: [],
    during_note_prompts: [],
    summary_direction_md: "",
    source_md: "",
  };
}

function mapLabel(label) {
  if (typeof label === "string") return { en: label, fr: label };
  return { en: label?.en || "", fr: label?.fr || "" };
}

function mapQs(qs, fallbackEmpty) {
  const rows = (qs || []).map((q, i) => ({
    ...q,
    key: q.key || `q${i + 1}`,
    label: mapLabel(q.label),
    options: q.options || [],
  }));
  if (!rows.length && fallbackEmpty) return [emptyQuestion(0)];
  return rows;
}

export function formFromTemplate(found) {
  return {
    name: found.name || "",
    description: found.description || "",
    session_type: found.session_type || "internal_1_1",
    audience: found.audience || ((found.session_type || "internal_1_1") === "advisory" ? "advisor" : "teammate"),
    is_default: !!found.is_default,
    questions: mapQs(found.before_questions || found.questions, true),
    after_questions: mapQs(found.after_questions, false),
    during_note_prompts: (found.during_note_prompts || []).map((p, i) => ({
      key: p.key || `prompt_${i + 1}`,
      label: mapLabel(p.label),
    })),
    summary_direction_md: found.summary_direction_md || "",
    source_md: found.source_md || "",
  };
}

function mapOut(q, i, prefix) {
  return {
    key: q.key || `${prefix}${i + 1}`,
    label: q.label,
    type: q.type,
    required: !!q.required,
    options: (q.options || []).filter(Boolean),
  };
}

export function payloadFromForm(form) {
  return {
    name: form.name,
    description: form.description,
    session_type: form.session_type,
    audience: form.audience,
    is_default: form.is_default,
    questions: form.questions.map((q, i) => mapOut(q, i, "q")),
    before_questions: form.questions.map((q, i) => mapOut(q, i, "q")),
    after_questions: form.after_questions.map((q, i) => mapOut(q, i, "after_")),
    during_note_prompts: (form.during_note_prompts || []).map((p, i) => ({
      key: p.key || `prompt_${i + 1}`,
      label: p.label,
    })),
    summary_direction_md: form.summary_direction_md,
    source_md: form.source_md || "",
  };
}
